/* ZOFF collection page (zk-* sections), 7 Oct 2026, from Downloads\ZOFF_Category_Page_v1.html.
   Nothing here holds catalogue data. The catalogue section (sections/zk-grid.liquid) prints every product of the collection with its live
   price, stock, rating and shelf/cooking membership; this file filters, sorts and pages them in place, as the design does.
   The cart is the site's real cart (window.ZH in zoff-ui.js, via data-zh-add). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  requestAnimationFrame(function () { document.body.classList.add('is-lit'); });

  /* ── Catalogue: the design's filter / sort / show-the-rest, on the real products ── */
  var shop = $('[data-zk-shop]');
  if (shop) {
    // The toolbar sticks right under the site header, whatever height it has (112px on phones, 84px on desktop).
    var hdr = document.querySelector('[id^="shopify-section-"][id*="zh_header"]');
    var setTop = function () {
      if (!hdr) return;
      var h = hdr.getBoundingClientRect().height + (parseFloat(getComputedStyle(hdr).top) || 0);
      shop.style.setProperty('--zk-top', Math.max(0, Math.round(h) - 1) + 'px');
    };
    setTop();
    window.addEventListener('resize', setTop);
    if (hdr && 'ResizeObserver' in window) new ResizeObserver(setTop).observe(hdr);

    var grid = $('[data-zk-grid]', shop);
    var cards = $$('.product-card', grid);
    var breakCard = $('[data-break]', grid);
    var emptyBox = $('[data-zk-empty]', grid);
    var countEl = $('[data-zk-count]', shop);
    var foot = $('[data-zk-foot]', shop), meter = $('[data-zk-meter]', shop), progress = $('[data-zk-progress]', shop), loadMore = $('[data-zk-more]', shop);
    var tallyEl = $('[data-zk-tally]', shop), openBtn = $('.filter-open', shop), applyNum = $('[data-zk-apply-count]', shop);
    var range = $('[data-zk-price]', shop), priceRead = $('[data-zk-price-read]', shop), priceMin = $('[data-zk-price-min]', shop);
    var sheet = $('#zk-filter', shop), sortSel = $('[data-zk-sort]', shop);
    var initial = Number(shop.getAttribute('data-initial')) || 16;
    var breakAfter = Number(shop.getAttribute('data-break-after')) || 8;
    var list = function (c, k) { return (c.getAttribute('data-' + k) || '').split(',').filter(Boolean); };
    var rupees = function (p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); };

    // Budget slider spans the real price range of this collection.
    var prices = cards.map(function (c) { return Number(c.getAttribute('data-price')) || 0; });
    var maxP = Math.max.apply(null, prices.concat([0])), minP = Math.min.apply(null, prices.length ? prices : [0]);
    var top = Math.max(5, Math.ceil(maxP / 100 / 5) * 5);
    if (range) {
      range.min = String(Math.floor(minP / 100 / 5) * 5); range.max = String(top); range.value = String(top);
      if (priceMin) priceMin.textContent = '₹' + range.min;
      if (priceRead) priceRead.textContent = 'Up to ₹' + top;
    }

    var state = { cats: [], tags: [], max: Infinity, sort: 'featured', expanded: false };
    function matches(c) {
      if (state.cats.length && !list(c, 'cat').some(function (v) { return state.cats.indexOf(v) > -1; })) return false;
      if (state.tags.length && !list(c, 'tags').some(function (v) { return state.tags.indexOf(v) > -1; })) return false;
      if (Number(c.getAttribute('data-price')) > state.max) return false;
      return true;
    }
    function activeCount() { return state.cats.length + state.tags.length + (state.max < Infinity ? 1 : 0); }
    function sortCards(arr) {
      var by = state.sort, n = function (c, k) { return Number(c.getAttribute('data-' + k)) || 0; };
      return arr.slice().sort(function (a, b) {
        if (by === 'low') return n(a, 'price') - n(b, 'price');
        if (by === 'high') return n(b, 'price') - n(a, 'price');
        if (by === 'rated') return (n(b, 'rating') - n(a, 'rating')) || (n(a, 'rank') - n(b, 'rank'));
        if (by === 'new') return (n(b, 'new') - n(a, 'new')) || (n(a, 'rank') - n(b, 'rank'));
        return n(a, 'rank') - n(b, 'rank');
      });
    }
    // As in the design (3D Refined, 8 Oct): with 3+ columns the grid opens on three full rows and the story card
    // sits after two; on phones it is the section settings (8 shown, story after 6).
    function gridCols() {
      var t = getComputedStyle(grid).gridTemplateColumns || '';
      return Math.max(1, t.split(' ').filter(Boolean).length);
    }
    function visibleCap() { var c = gridCols(); return c >= 3 ? c * 3 : initial; }
    function breakAt() { var c = gridCols(); return c >= 3 ? c * 2 : breakAfter; }
    function render(animate) {
      var cap = visibleCap(), at = breakAt();
      var ordered = sortCards(cards.filter(matches));
      if (animate && !reduce) { grid.style.opacity = '.35'; setTimeout(function () { grid.style.opacity = ''; }, 180); }
      ordered.forEach(function (c) { grid.appendChild(c); });
      var limit = state.expanded ? ordered.length : Math.min(cap, ordered.length);
      cards.forEach(function (c) { c.classList.add('is-hidden'); });
      ordered.slice(0, limit).forEach(function (c) { c.classList.remove('is-hidden'); });
      if (breakCard) {
        var plain = activeCount() === 0 && state.sort === 'featured';
        breakCard.hidden = !plain || ordered.length <= at;
        if (!breakCard.hidden) grid.insertBefore(breakCard, ordered[at]);
      }
      grid.appendChild(emptyBox);
      emptyBox.hidden = ordered.length !== 0;
      countEl.textContent = ordered.length + (ordered.length === 1 ? ' product' : ' products');
      if (applyNum) applyNum.textContent = ordered.length;
      var n = activeCount();
      if (tallyEl) tallyEl.textContent = n;
      if (openBtn) openBtn.classList.toggle('has-filters', n > 0);
      foot.hidden = ordered.length <= cap;
      if (!foot.hidden) {
        progress.textContent = 'Showing ' + limit + ' of ' + ordered.length;
        meter.style.width = Math.round(limit / ordered.length * 100) + '%';
        loadMore.hidden = limit >= ordered.length;
      }
    }

    // Counts come from the products on the page; an option nothing matches is hidden.
    $$('[data-count]', shop).forEach(function (el) {
      var p = el.getAttribute('data-count').split(':'), kind = p[0], v = p[1], n;
      if (v === 'all') n = cards.length;
      else n = cards.filter(function (c) { return list(c, kind === 'cat' ? 'cat' : 'tags').indexOf(v) > -1; }).length;
      el.textContent = n;
      var host = el.closest('.chip, .opt');
      if (host && v !== 'all' && n === 0) host.hidden = true;
    });
    $$('.filter-group', shop).forEach(function (g) {
      var opts = $$('.opt', g);
      if (opts.length && opts.every(function (o) { return o.hidden; })) g.hidden = true;
    });

    var chips = $$('.chip', shop);
    function sync() {
      chips.forEach(function (ch) {
        var v = ch.getAttribute('data-cat');
        ch.setAttribute('aria-pressed', (v === 'all' ? state.cats.length === 0 : state.cats.indexOf(v) > -1) ? 'true' : 'false');
      });
      $$('.opt', shop).forEach(function (o) {
        var key = o.getAttribute('data-filter') === 'cat' ? 'cats' : 'tags';
        o.setAttribute('aria-pressed', state[key].indexOf(o.getAttribute('data-value')) > -1 ? 'true' : 'false');
      });
      $$('.rail-card[data-zk-jump]').forEach(function (r) {
        r.classList.toggle('is-current', state.cats.length ? (state.cats.length === 1 && state.cats[0] === r.getAttribute('data-zk-jump')) : r.hasAttribute('aria-current'));
      });
    }
    function toggle(arr, v) { var i = arr.indexOf(v); if (i === -1) arr.push(v); else arr.splice(i, 1); }

    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        var v = ch.getAttribute('data-cat');
        if (v === 'all') state.cats = []; else toggle(state.cats, v);
        state.expanded = false; sync(); render(true);
      });
    });
    $$('.opt', shop).forEach(function (o) {
      o.addEventListener('click', function () {
        toggle(state[o.getAttribute('data-filter') === 'cat' ? 'cats' : 'tags'], o.getAttribute('data-value'));
        state.expanded = false; sync(); render(false);
      });
    });
    if (range) range.addEventListener('input', function () {
      var v = Number(range.value);
      state.max = v >= top ? Infinity : v * 100;
      priceRead.textContent = 'Up to ₹' + v;
      state.expanded = false; render(false);
    });
    function clearAll() {
      state.cats = []; state.tags = []; state.max = Infinity; state.expanded = false;
      if (range) { range.value = String(top); priceRead.textContent = 'Up to ₹' + top; }
      sync(); render(true);
    }
    $$('[data-zk-clear]', shop).forEach(function (b) { b.addEventListener('click', clearAll); });
    $('[data-zk-apply]', shop).addEventListener('click', function () {
      if (sheet && sheet.open) sheet.close();
      var g = $('#grid', shop); if (g && g.getBoundingClientRect().top < 0) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    });
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.expanded = false; render(true); });
    loadMore.addEventListener('click', function () { state.expanded = true; render(false); loadMore.blur(); });

    // Shelf and dish links in this page's sections (rail cards, dish carousel) filter in place when the
    // collection they point to is one of this grid's options and has products here; otherwise they open the page.
    var known = {};
    $$('.opt', shop).forEach(function (o) { if (!o.hidden) known[o.getAttribute('data-value')] = o.getAttribute('data-filter'); });
    $$('a[href*="/collections/"]').forEach(function (a) {
      // only this page's own sections (.zk): the site header, mega menu, drawers and footer are not .zk and must
      // always open the real collection page (15 Oct 2026: on /collections/all every menu link jumped to the grid)
      if (!a.closest('.zk') || a.closest('[data-zk-shop], header, footer, nav')) return;
      // 15 Oct 2026 (client): the shelf rail cards always open their own collection page
      if (a.classList.contains('rail-card')) return;
      var h = (a.getAttribute('href').split('/collections/')[1] || '').split(/[?#/]/)[0];
      if (!known[h]) return;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        if (known[h] === 'cat') { state.cats = [h]; state.tags = []; } else { state.tags = [h]; state.cats = []; }
        state.expanded = false; sync(); render(true);
        var g = $('#grid', shop); if (g) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    $$('a[href="#grid"]').forEach(function (a) {
      a.addEventListener('click', function () { if (a.closest('.rail-head')) { clearAll(); } });
    });

    sync(); render(false);
    // a phone turned sideways (or a resized window) changes the column count: re-cut the rows
    var lastCols = gridCols();
    window.addEventListener('resize', function () { var c = gridCols(); if (c !== lastCols) { lastCols = c; render(false); } });
  }

  /* ── Spice spinner ─────────────────────────────────────────────────────── */
  $$('[data-zk-roulette]').forEach(function (wrap) {
    var pool = [];
    try { pool = JSON.parse($('[data-zk-r-pool]', wrap).textContent); } catch (_) {}
    if (!pool.length) return;
    var img = $('[data-zk-r-img]', wrap), nameEl = $('[data-zk-r-name]', wrap), metaEl = $('[data-zk-r-meta]', wrap);
    var priceEl = $('[data-zk-r-price]', wrap), live = $('[data-zk-r-live]', wrap), link = $('[data-zk-r-link]', wrap);
    var spin = $('[data-zk-r-spin]', wrap), add = $('[data-zk-r-add]', wrap);
    var addLabel = add.textContent.trim(), spinLabel = spin.textContent.trim();
    var pick = null, rolling = false;

    function paint(p) {
      img.src = p.i; img.alt = p.a || p.t; img.classList.toggle('is-tile', !p.c);
      nameEl.textContent = p.t; metaEl.textContent = p.m || ' '; priceEl.textContent = p.p;
      link.href = p.u; link.setAttribute('aria-label', 'View ' + p.t);
    }
    function settle() {
      if (live) live.textContent = pick.t + ', ' + pick.p;
      spin.querySelector('span').textContent = spinLabel;
      add.querySelector('span').textContent = addLabel;
      add.classList.remove('is-added');
      wrap.classList.remove('is-popping'); void wrap.offsetWidth; wrap.classList.add('is-popping');
      spin.disabled = false; rolling = false;
    }
    function roll() {
      if (rolling) return;
      rolling = true; spin.disabled = true;
      spin.querySelector('span').textContent = 'Shuffling';
      var next;
      do { next = pool[Math.floor(Math.random() * pool.length)]; } while (pool.length > 1 && pick && next.v === pick.v);
      if (reduce) { pick = next; paint(pick); settle(); return; }
      wrap.classList.add('is-spinning');
      var ticks = 11, i = Math.floor(Math.random() * pool.length);
      var iv = setInterval(function () {
        nameEl.textContent = pool[i % pool.length].t;
        i += 1 + Math.floor(Math.random() * 3);
        if (++ticks >= 22) {
          clearInterval(iv);
          pick = next; paint(pick);
          wrap.classList.remove('is-spinning');
          settle();
        }
      }, 70);
    }
    spin.addEventListener('click', roll);
    add.addEventListener('click', function () {
      if (!pick || !window.ZH) return;
      window.ZH.add(pick.v, 1, pick.t, add).then(function () {
        add.classList.add('is-added');
        add.querySelector('span').textContent = 'In the bag';
      });
    });
    pick = pool[Math.floor(Math.random() * pool.length)];
    // The pool's first image only loads when the card nears the screen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { paint(pick); io.disconnect(); } }, { rootMargin: '400px 0px' });
      io.observe(wrap);
    } else paint(pick);
  });

  /* ── Dish carousel: auto-advances, pauses on interaction ──────────────── */
  $$('[data-zk-carousel]').forEach(function (box) {
    var track = $('[data-zk-track]', box);
    var slides = $$('.dish-link', track);
    if (!slides.length) return;
    var idxEl = $('[data-zk-index]', box), prev = $('[data-zk-prev]', box), next = $('[data-zk-next]', box);
    var timer = null, paused = false;
    function current() {
      var best = 0, min = Infinity;
      slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.scrollLeft); if (d < min) { min = d; best = i; } });
      return best;
    }
    function perView() { return Math.max(1, Math.round(track.clientWidth / (slides[0].offsetWidth + 14))); }
    function goTo(i) {
      var max = slides.length - perView();
      var target = i > max ? 0 : (i < 0 ? max : i);
      track.scrollTo({ left: slides[target].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      idxEl.textContent = current() + 1;
      var off = slides.length - perView() <= 0;
      prev.disabled = off; next.disabled = off;
      if (off) stop();
    }
    function start() { if (reduce || timer) return; timer = setInterval(function () { if (!paused) goTo(current() + 1); }, 4800); }
    function stop() { clearInterval(timer); timer = null; }
    prev.addEventListener('click', function () { goTo(current() - 1); });
    next.addEventListener('click', function () { goTo(current() + 1); });
    track.addEventListener('scroll', function () { clearTimeout(track._t); track._t = setTimeout(sync, 90); }, { passive: true });
    ['pointerenter', 'focusin', 'pointerdown'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }); });
    ['pointerleave', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }); });
    document.addEventListener('visibilitychange', function () { paused = document.hidden; });
    window.addEventListener('resize', sync);
    sync();
    /* 2 Nov 2026: auto-advance only while the carousel is on screen. It used to start on page load, so by the
       time a shopper scrolled down to it, it had already moved on from the first dish. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); else stop(); }, { threshold: 0.5 }).observe(box);
    } else {
      start();
    }
  });
})();
